import { GridInputValue } from '../../types/types';

// Layouts API color pattern: 6 hex digits, leading `#` optional (editor.definitions.json).
const HEX_COLOR_PATTERN = /^#?[0-9A-Fa-f]{6}$/;

export const isValidLayoutHexColor = (value: GridInputValue): boolean =>
  typeof value === 'string' && HEX_COLOR_PATTERN.test(value);
